module.exports = __webpack_public_path__ + "static/media/PEDALCORDEROSA.a0ae5991.jpeg";